import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto, Sgke361aRequest, Sgke361aResponse, Sgke362aRequest, Sgke363aRequest, Sgke902aRequest, } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { UsedSgke902aService } from '../../../../../sg-ke-shared/services/used-sgke902a.service';
import { UsedSzza006aService } from '../../../../../sg-ke-shared/services/used-szza006a.service';
import { Sgke360dRegistAreaComponent } from '../../components/sgke360d-regist-area/sgke360d-regist-area.component';
import { UsedSgke361aService } from '../../services/used-sgke361a.service';
import { UsedSgke362aService } from '../../services/used-sgke362a.service';
import { UsedSgke363aService } from '../../services/used-sgke363a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

/**
 * 供給再開結果登録画面
 *
 * @export
 * @class Sgke360dComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'app-sgke360d',
  templateUrl: './sgke360d.component.html',
  styleUrl: './sgke360d.component.scss'
})
export class Sgke360dComponent implements OnInit, OnDestroy {
  /** 登録区分値定義 */
  regDiv = {
    regist: "1",
    cancel: "2",
    navigate: "3"
  } as const;

  /** 全体リクエストフォームグループ */
  requestFormGroup: UntypedFormGroup;

  /** コード変換マスタマップ */
  codeMap: Map<string, CodeConversionMstDto[]> = null;

  /** 初期化APIの返り値 */
  initResponse: Sgke361aResponse = null;

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 供給地点特定番号 */
  suppntSpno: string;
  /** 供給停止再開履歴番号 */
  supplystopresumptionRrkno: string;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** 登録エリア子コンポーネント */
  @ViewChild(Sgke360dRegistAreaComponent) public childComponent: Sgke360dRegistAreaComponent

  // エラーメッセージ表示制御
  isErrorMessageDisplay: boolean = true;

  // 作業種別コード
  workClscode: string = null;

  /**
   * コンストラクタ
   * @memberof Sgke360dComponent
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    private codeConvert: CodeConversionMstService,
    public initService: UsedSgke361aService,
    private registService: UsedSgke362aService,
    private cancelService: UsedSgke363aService,
    private uploadService: UsedSzza006aService,
    private rescheduleService: UsedSgke902aService,
    private responseMsgUtils: ResponseMsgUtils,
  ) {
    // routeで渡されたデータを取得
    this.suppntSpno = this.route.snapshot.paramMap.get('suppntSpno').toString();
    this.supplystopresumptionRrkno = this.route.snapshot.paramMap.get('supplystopresumptionRrkno').toString();
  }

  /**
   * 画面初期化
   *
   * @memberof Sgke360dComponent
   */
  ngOnInit(): void {
    // リクエストフォームグループ初期化
    this.requestFormGroup = this.fb.group({
      requestCommon: {},
    });
    // コード変換マスタ取得
    const dispItemIdList = [
      'S300842',
      'S300800',
      'S301270',
      'S301290',
      'S301300',
      'S301310',
      'S301320',
      'S301330',
      'S301340',
      'S301380',
      'S300860',
      'S300870',
      'S300890',
      'S001020',
      'S300772',
      'S300530',
    ];
    //コード変換マスタ共通コンポーネント呼び出し
    this.codeConvert.getCodeConversionMst(dispItemIdList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(codeMap => {
        // ローカルに保存
        this.codeMap = codeMap;
      });

    this.init();
  }
  /**
   * 画面終了処理
   *
   * @memberof Sgke360dComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * ボタンクリック
   *
   * @param {*} button ボタン名
   * @memberof Sgke360dComponent
   */
  public async onClickButton(button: string) {
    // 供給停止再開結果区分コードを保持
    const resultDiv = this.getSupplyControl(
      'supplystopresumptionResultDivcd'
    ).value;

    if (button == this.regDiv.regist) {
      // 登録ボタンの場合
      if (resultDiv == '1') {
        // 延期の場合
        this.reschedule();
      } else if (resultDiv == '2') {
        // 再開中止の場合
        this.cancel();
      } else if (
        this.initResponse.initialhyojiInfo.basicInfoArea.suppntInfo
          .workClscode == '3'
      ) {
        // 簡易供給再開の場合は登録処理に進む
        this.regist(null, button);
      } else {
        // 一般供給再開の場合は署名画像ファイルアップロード
        const imageFile =
          await this.childComponent.lastCofirmComponent.getImageFile(
            '供給再開結果署名.png',
            'image/png'
          );
        this.uploadSignImage(imageFile, button);
      }
    } else if (button == this.regDiv.cancel) {
      // 中断ボタンの場合
      if (
        this.initResponse.initialhyojiInfo.basicInfoArea.suppntInfo
          .workClscode == '3'
      ) {
        // 簡易供給再開の場合は登録処理に進む
        this.regist(null, button);
      } else {
        // 一般供給再開の場合は署名画像ファイルアップロード
        const imageFile =
          await this.childComponent.lastCofirmComponent.getImageFile(
            '供給再開結果署名.png',
            'image/png'
          );
        this.uploadSignImage(imageFile, button);
      }
    } else if (button == this.regDiv.navigate) {
    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;
    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = this.initResponse.initialhyojiInfo.basicInfoArea.clmtoInfo.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = this.initResponse.initialhyojiInfo.basicInfoArea.clmtoInfo.payCtrNo;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '14';

    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };

    // 別タブで該当URLを開く
    window.open(`${url}${params}`, '_blank');
    }
  }

  /**
   * 供給再開結果登録初期表示API呼び出し
   */
  private init() {
    // メッセージクリア
    this.clearErrorMsg();

    // Formの内容をリクエストに設定
    let request: Sgke361aRequest = {
      requestCommon: null,
      suppntSpno: this.suppntSpno,
      supplystopresumptionRrkno: this.supplystopresumptionRrkno,
    };

    //SGKE361A_供給再開結果初期表示API呼び出し
    this.initService.doSgke361a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response) {
            // レスポンスを設定
            this.initResponse = response;
            // 作業種別コード設定
            this.workClscode = this.initResponse?.initialhyojiInfo?.basicInfoArea?.suppntInfo?.workClscode;
            // メッセージを表示
            this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
          }
        }, error => {
        });
  }

  /**
   * 署名画像ファイルアップロード
   *
   * @private
   * @param {File} imageFile
   * @memberof Sgke360dComponent
   */
  private uploadSignImage(imageFile: File, button: string) {
    // 一般供給再開の場合のみアップロード
    this.uploadService.upload('00010', imageFile)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response) {
            this.regist(response.uploadInternalFileName, button);
            // メッセージを表示
            this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
          }
        },
        error => {
        }
      );
  }

  /**
   * 供給再開結果登録API呼び出し
   *
   * @param {string} filePath アップロードしたファイルパス
   * @param {string} button ボタン種別　
   * @memberof Sgke360dComponent
   */
  private regist(filePath: string, button: string) {
    // 供給地点特定番号
    this.getSupplyControl('suppntSpno')?.setValue(this.suppntSpno);
    // 供給停止再開履歴番号
    this.getSupplyControl('supplystopresumptionRrkno')?.setValue(this.supplystopresumptionRrkno);
    // 登録区分
    this.getSupplyControl('regDiv')?.setValue(button);
    // 点検業務引継先フラグ:点検業務引継先が選択済なら'1'選択済、それ以外は'0'未選択
    var inspectiontaskTakeovertoFlg = this.getSupplyControl('inspectiontaskTakeovertoCode').value ? '1' : '0';
    this.getSupplyControl('inspectiontaskTakeovertoFlg')?.setValue(inspectiontaskTakeovertoFlg);

    // 署名にファイルパスを設定
    this.getSupplyControl('signature').setValue(filePath);

    // Formの内容をリクエストに設定
    let request: Sgke362aRequest = this.requestFormGroup.getRawValue();

    // 供給再開時刻
    const supplyresumptionHms = request.supplyresumptionResultInfo.supplyresumptionHms;
    request.supplyresumptionResultInfo.supplyresumptionHms = supplyresumptionHms ? supplyresumptionHms.replace(/^(\d{2}):(\d{2}).*$/, '$1$2') : null;

    //SGKE362A_供給再開結果登録API呼び出し
    this.registService.doSgke362a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response) {
            // 成功として担当作業一覧に戻る
            this.router.navigate(['sgke/sgke330d/'], {
              state: {
                errors: response?.responseCommon?.errors,
              },
            });
          }
        }, error => {
        });
  }
  //延期
  private reschedule() {
    // Formの内容をリクエストに設定
    let request: Sgke902aRequest = {
      requestCommon: null,
      supplystopresumptionResultInfo: {
        callmotoFuncDiv: this.getSupplyControl('workClscode').value,
        suppntSpno: this.getSupplyControl('suppntSpno').value,
        supplystopresumptionRrkno: this.getSupplyControl('supplystopresumptionRrkno').value,
        updateSrno: this.getSupplyControl('supplystopresumptionPointinfomngUpdatesequencenumber').value,
        userName: this.getKykctnControl('userVisitName').value,
        visitName: this.getSupplyControl('visitName').value,
        workPlaceCode: this.getSupplyControl('workPlaceCode').value,
        supplystopResultDivcd: null,
        supplyresumptionResultDivcd: this.getSupplyControl('supplystopresumptionResultDivcd').value,
        workTimeBf: this.getSupplyControl('bfSupplyresumptionScddt').value,
        workTimeAf: this.getSupplyControl('afSupplyresumptionScddt').value,
        workTimezone: this.getSupplyControl('afSupplyresumptionYtitimez').value,
      },
      supplyresumptionResultregistrationConsumptiondeviceinfoList:
        this.requestFormGroup.controls['supplyresumptionResultregistrationConsumptiondeviceinfoList'].value
    };

    //SGKE902A_供給停止・再開延期登録API呼び出し
    this.rescheduleService.doSgke902a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response) {
            // 成功として担当作業一覧に戻る
            this.router.navigate(['sgke/sgke330d'], {
              state: {
                errors: response?.responseCommon?.errors,
              },
            });
          }
        }, error => {
        });
  }
  // 再開中止
  private cancel() {
    // Formの内容をリクエストに設定
    let request: Sgke363aRequest = this.requestFormGroup.getRawValue();

    //SGKE363A_供給再開結果中止API呼び出し
    this.cancelService.doSgke363a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response) {
            // 成功として担当作業一覧に戻る
            this.router.navigate(['sgke/sgke330d'], {
              state: {
                errors: response?.responseCommon?.errors,
              },
            });
          }
        }, error => {
        });
  }

  /**
 * エラーメッセージ表示領域をクリア
 * @private
 * @memberof Sgke360dComponent
 */
  private clearErrorMsg() {
    this.errorMessageModelArray.length = 0;
  }

  /**
   * 供給再開結果情報コントロール取得
   *
   * @private
   * @param {*} ctlName コントロール名
   * @return {*} コントロール
   * @memberof Sgke360dComponent
   */
  public getSupplyControl(ctlName) {
    const supplyForm = this.requestFormGroup.controls['supplyresumptionResultInfo'] as UntypedFormGroup;
    return supplyForm.controls[ctlName];
  }
  /**
   * 供給停止再開地点情報管理情報コントロール取得
   *
   * @private
   * @param {*} ctlName コントロール名
   * @return {*} コントロール
   * @memberof Sgke360dComponent
   */
  private getKykctnControl(ctlName) {
    const kykctnForm = this.requestFormGroup.controls['supplystopresumptionPointinfomngInfo'] as UntypedFormGroup;
    return kykctnForm.controls[ctlName];
  }

  /**
   * モーダル表示非表示イベント時の処理
   * @param isDisplay 表示非表示判定イベント boolean
   * @memberof Sgke360dComponent
   */
  onModalIsDisplay(isDisplay: boolean): void {
    // モーダル表示非表示イベント時、エラーメッセージ表示エリア表示非表示を切り替える
    // true 表示する
    // false 非表示にする
    this.isErrorMessageDisplay = isDisplay;
  };

}
